import { useEffect, useState } from "react";
import Accordion from "./accordian";
import TaskCard from "./taskCard";
import { getTaskTemplate, saveTaskTemplate } from "../../utils/firebasefunctions";
import { cleanTemplate } from "../../utils/taskSections";
import SectionRow from "./sectionRow";
import { groupTemplateItems, isSectionItem } from "../../utils/taskSections";
import { STARTER_CHECKLIST } from "../../utils/starterChecklist";
import { useActionDialog } from "../ActionDialog";
import { useStateValue } from "../../context/StateProvider";
import { isSuperAdminOwner } from "../../utils/brokerageSettings";

function MainTaskTemplate() {
  const [{ user }] = useStateValue();
  const [tasks, setTasks] = useState({});
  const [editingTaskId, setEditingTaskId] = useState(null);
  const { confirm, dialog } = useActionDialog();
  const STATUSES = [
    "Prospect",
    "On Hold",
    "CMAs",
    "Listing Appointment",
    "Pre-Market",
    "Coming Soon",
    "Active",
    "Under Contract",
    "Pending",
    "Closed",
    "Cancelled",
    "Expired",
  ];

  const addNewTask = async (status) => {
    const newTask = {
      id: Date.now(),
      type: "task",
      title: "",
      assignee: null,
      deadline: "",
      image: null,
      createdAt: new Date(),
    };

    const updatedTasks = {
      ...tasks,
      [status]: [newTask, ...(tasks[status] || [])],
    };

    setTasks(updatedTasks);
    setEditingTaskId(newTask.id);

    await saveTaskTemplate(cleanTemplate(updatedTasks));
  };

  const addNewSection = async (status) => {
    const newSection = { type: "section", id: Date.now(), title: "New Section" };
    const updatedTasks = { ...tasks, [status]: [...(tasks[status] || []), newSection] };
    setTasks(updatedTasks);
    await saveTaskTemplate(cleanTemplate(updatedTasks));
  };

  const importStarterChecklist = async () => {
    const hasContent = Object.values(tasks || {}).some((arr) => Array.isArray(arr) && arr.length > 0);
    const ok = await confirm({
      title: "Import the starter checklist",
      body: hasContent
        ? "This replaces your current Task Template with the starter checklist."
        : "Import the starter checklist into your Task Template?",
      confirmLabel: "Import",
    });
    if (!ok) return;
    setTasks(STARTER_CHECKLIST);
    await saveTaskTemplate(cleanTemplate(STARTER_CHECKLIST));
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log('data', data)
    };

    fetchData();
  }, []);

  return (
    <div>
      {(isSuperAdminOwner(user) || user?.role === "Admin") && (
      <div className="flex justify-end items-center gap-3 px-2 mb-3">
        {/* The repair tools moved to Settings → Super Admin (one home for all
            of them, 2026-08-30). Only the template-seeding button lives here. */}
        <span className="text-xs text-slate-400">
          Looking for the repair tools? They moved to Settings → Super Admin.
        </span>
        <button
          onClick={importStarterChecklist}
          className="text-sm font-semibold text-white bg-[#1E293B] hover:bg-green-600 px-4 py-2 rounded-lg transition"
        >
          Import Starter Checklist
        </button>
      </div>
      )}
      {/* <header className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left px-10 py-7 lg:py-5 border-b border-black/10 bg-white">
        <div className="page-title">
          <h2 className="text-3xl sm:text-4xl font-bold bg-[#1E293B] bg-clip-text text-transparent">
            Task Template
          </h2>
        </div>
      </header> */}
      <div className="rounded-lg">
        {STATUSES.map((status) => {
          const statusTasks = tasks[status] || [];
          const taskCount = statusTasks.filter((it) => !isSectionItem(it)).length;
          const groups = groupTemplateItems(statusTasks);

          return (
            <Accordion
              key={status}
              title={status}
              count={taskCount}
              onAdd={() => addNewTask(status)}
              onAddSection={() => addNewSection(status)}
            >
              {/* HEADER */}
              <div className="justify-between w-full text-sm items-center flex">
                <div className="w-[45%] lg:w-[45%] ml-2">Task Name</div>
                <div className="w-[15%] lg:w-[20%] text-center">Assign</div>
                <div className="w-[25%] lg:w-[20%] text-center">Attachments</div>
                <div className="w-[10%] lg:w-[15%] text-center mr-3 md:mr-0">Action</div>
              </div>

              {/* GROUPS */}
              {taskCount === 0 && groups.length === 0 ? (
                <p className="text-sm text-gray-400 text-center py-3">No tasks</p>
              ) : (
                groups.map((g) => (
                  <div key={g.section ? g.section.id : "loose"}>
                    {g.section && (
                      <SectionRow
                        section={g.section}
                        status={status}
                        tasks={tasks}
                        setTasks={setTasks}
                        setEditingTaskId={setEditingTaskId}
                      />
                    )}
                    {g.tasks.map((task) => (
                      <TaskCard
                        key={task.id}
                        task={task}
                        tasks={tasks}
                        setTasks={setTasks}
                        status={status}
                        editingTaskId={editingTaskId}
                        setEditingTaskId={setEditingTaskId}
                      />
                    ))}
                  </div>
                ))
              )}
            </Accordion>
          );
        })}
      </div>
      {dialog}
    </div>
  );
}

export default MainTaskTemplate;
